<template>
    <div id="PhoneDetails">
        <div class="info-title">
            {{infoData && infoData.title}}
        </div>
        <div class="info-subtitle">
            <!-- <span>游客汤姆</span>
            <span>|</span> -->
            <span>{{infoData && infoData.addTime}}</span>
        </div>
        <div class="phone-content" v-html="infoData && infoData.content"></div>
    </div>
</template>

<script>
    export default {
        name: 'PhoneDetails',
        data() {
            return {
                infoData: ''
            }
        },
        methods: {
            getParams() {
                let id = this.$route.query.id
                this.getData(id)
            },
            getData(id) {
                this.$common.querystringifyPost('/hdweb/portal/getPropagateInfoById', {
                    id
                }).then(res => {
                    // console.log(res.data.content)
                    // let reg = /style\s*?=\s*?(['"])[\s\S]*?\1/
                    this.infoData = res.data
                    // let s = this.infoData.content
                    this.infoData.content = this.infoData.content.replace(/style\s*?=\s*?([‘"])[\s\S]*?\1/gi, '')
                    // console.log(s)
                })
            }
        },
        created() {
            this.getParams()
        }
    }
</script>

<style scoped lang="less">
    #PhoneDetails {
        width: 90%;
        margin: 0 auto;

        .info-title {
            margin-top: 5vh;
            font-size: 1.5rem;
            text-align: center;
        }

        .info-subtitle {
            margin: 2vh 0;
        }
        .phone-content {
            font-size: 14px;
            line-height: 30px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/details/PhoneDetails.vue